import { useContext, useState } from "react";
import Context from "../../../Context.js";
import { useTranslation } from "react-i18next";
import AnimatedNavHorizontal from "../loggedOut/landingPage/loggedOutHomeForApp/AnimatedNavHorizontal.js";
import { BiSearch } from "react-icons/bi";
import { RiHome5Line } from "react-icons/ri";
import { AiOutlineUser } from "react-icons/ai";
import { VscBell } from "react-icons/vsc";

export default function NavBarMobile() {
  const { loggedInUser, notificationCount } = useContext(Context);
  const { t } = useTranslation();
  const [tabIndex, setTabIndex] = useState(0);

  // if (!loggedInUser) return null;

  let options = [
    {
      value: "HOME",
      label: "Home",
      icon: <RiHome5Line />,
      link: "/",
    },
    {
      value: "NOTIFICATION",
      label: "Notification",
      icon: <VscBell />,
      link: "/notifications",
      badge: notificationCount,
    },
    {
      value: "SEARCH",
      label: "Search",
      icon: <BiSearch />,
      link: "/search",
    },
    {
      value: "PROFILE",
      label: "Profile",
      icon: <AiOutlineUser />,
      link: loggedInUser ? `/u/${loggedInUser.username}` : "/",
    },
  ];

  return (
    <AnimatedNavHorizontal
      tabs={options}
      activeIndex={tabIndex}
      setActiveIndex={setTabIndex}
    />
  );
}
